module.exports = __webpack_public_path__ + "media/images/emblems/St._Ursen-coat_of_arms-d9c32633661ef0063f5e0522f7eeae35.svg";